module.exports = __webpack_public_path__ + "img/faq2.a7c69004.png";